import React, { FunctionComponent } from "react";

const RoundSubmitButton:FunctionComponent<{value:string,className?:string,disabled:boolean}> = ({value,className,disabled})=> {
    return(
        <input type="submit" disabled={disabled} data-testid="round-button" className={`bg-bytestrone-green text-white  p-2 text-sm  md:p-3 md:text-base rounded-full font-bold focus:outline-none disabled:opacity-50 ${className}`} value={value}/>
    )
}

export default RoundSubmitButton;